import axios from "axios";
import API_URL from "./ApiUrl";

export const axiosClient = axios.create({
  baseURL: API_URL.superStudent,
  headers: {
    'Accept': 'application/json',
    'Authorization': `Bearer ${API_URL.masterKey}`
  },
});